import React from "react";
import styled from "styled-components";

const SVG = styled.svg`
  /* width: 1em; */
  fill: currentColor;
`;

const Icon = ({ size = 24, viewBox = "0 0 24 24", icon, ...otherProps }) => (
  <SVG width={size} height={size} viewBox={viewBox} {...otherProps}>
    <path d={icon} />
  </SVG>
);

export default Icon;



// WEBPACK FOOTER //
// ./src/components/Icon.js